const customToastStyles = `
  #custom-toast-container {
    position: fixed;
    top: 20px;
    right: 20px;
    z-index: 9999;
    display: flex;
    flex-direction: column;
    gap: 8px;
    pointer-events: none;
  }

  .custom-toast-clear-all {
    display: flex;
    justify-content: flex-end;
    pointer-events: auto;
  }

  .custom-toast-clear-all button {
    background: #363636;
    color: #fff;
    border: 1px solid rgba(255, 255, 255, 0.2);
    padding: 6px 14px;
    border-radius: 6px;
    font-size: 12px;
    font-weight: 500;
    cursor: pointer;
    transition: background 0.2s ease, border-color 0.2s ease;
  }

  .custom-toast-clear-all button:hover {
    background: #4a4a4a;
    border-color: rgba(255, 255, 255, 0.35);
  }

  .custom-toast-clear-all button:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  .custom-toast {
    background: #363636;
    color: #fff;
    padding: 12px 16px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    gap: 12px;
    min-width: 300px;
    width: 300px;
    position: relative;
    transition: all 0.3s ease;
    pointer-events: auto;
    cursor: default;
  }

  .custom-toast .close-button {
    position: absolute;
    top: -5px;
    right: -5px;
    background: rgba(0, 0, 0, 0.8);
    color: white;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 11px;
    font-weight: bold;
    cursor: pointer;
    z-index: 1000;
    transition: all 0.2s ease;
  }

  .custom-toast .close-button:hover {
    background: rgba(0, 0, 0, 0.9);
    transform: scale(1.1);
  }

  .custom-toast .error-icon {
    background: #EF4444;
    color: white;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    font-weight: bold;
    flex-shrink: 0;
  }

  .custom-toast .success-icon {
    background: #10B981;
    color: white;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    font-weight: bold;
    flex-shrink: 0;
  }

  .custom-toast .loading-icon {
    background: #6B7280;
    color: white;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    font-weight: bold;
    flex-shrink: 0;
  }
`;

const styleSheet = document.createElement("style");
styleSheet.textContent = customToastStyles;
document.head.appendChild(styleSheet);

const DISMISS_DURATION_MS = 300;

class CustomToastManager {
  constructor() {
    this.toasts = [];
    this.container = null;
    this.isClearing = false;
    this.init();
  }

  init() {
    this.container = document.createElement("div");
    this.container.id = "custom-toast-container";
    document.body.appendChild(this.container);
  }

  addToast(message, type = "error") {
    const id = Date.now() + Math.random();
    this.toasts.push({ id, message, type, element: null });
    this.render();
    return id;
  }

  animateOut(element) {
    if (!element) return;
    element.style.transform = "translateX(100%)";
    element.style.opacity = "0";
    element.style.height = "0";
    element.style.margin = "0";
    element.style.padding = "0";
    element.style.overflow = "hidden";
  }

  removeToast(id) {
    if (this.isClearing) return;

    const toast = this.toasts.find((t) => t.id === id);
    if (!toast) return;

    this.animateOut(toast.element);

    setTimeout(() => {
      this.toasts = this.toasts.filter((t) => t.id !== id);
      this.render();
    }, DISMISS_DURATION_MS);
  }

  clearAll() {
    if (this.toasts.length === 0 || this.isClearing) return;

    this.isClearing = true;
    this.toasts.forEach((toast) => this.animateOut(toast.element));

    setTimeout(() => {
      this.toasts = [];
      this.isClearing = false;
      this.render();
    }, DISMISS_DURATION_MS);
  }

  createToastIcon(type) {
    const icon = document.createElement("div");
    if (type === "success") {
      icon.className = "success-icon";
      icon.innerHTML = "✓";
    } else if (type === "loading") {
      icon.className = "loading-icon";
      icon.innerHTML = "…";
    } else {
      icon.className = "error-icon";
      icon.innerHTML = "✕";
    }
    return icon;
  }

  render() {
    this.container.innerHTML = "";

    if (this.toasts.length === 0) return;

    const clearAllBar = document.createElement("div");
    clearAllBar.className = "custom-toast-clear-all";

    const clearAllButton = document.createElement("button");
    clearAllButton.type = "button";
    clearAllButton.textContent = "Clear All";
    clearAllButton.disabled = this.isClearing;
    clearAllButton.addEventListener("click", (e) => {
      e.stopPropagation();
      this.clearAll();
    });

    clearAllBar.appendChild(clearAllButton);
    this.container.appendChild(clearAllBar);

    this.toasts.forEach((toast) => {
      const toastElement = document.createElement("div");
      toastElement.className = "custom-toast";

      const closeButton = document.createElement("div");
      closeButton.className = "close-button";
      closeButton.innerHTML = "✕";
      closeButton.addEventListener("click", (e) => {
        e.stopPropagation();
        this.removeToast(toast.id);
      });

      const messageElement = document.createElement("span");
      messageElement.textContent = toast.message;

      toastElement.appendChild(this.createToastIcon(toast.type));
      toastElement.appendChild(messageElement);
      toastElement.appendChild(closeButton);

      toast.element = toastElement;
      this.container.appendChild(toastElement);
    });
  }
}

const customToastManager = new CustomToastManager();

export const toast = {
  error: (message) => customToastManager.addToast(message, "error"),
  success: (message) => customToastManager.addToast(message, "success"),
  dismiss: (id) => {
    if (id) {
      customToastManager.removeToast(id);
    } else {
      customToastManager.clearAll();
    }
  },
  loading: (message) => customToastManager.addToast(message, "loading"),
  promise: (promise, msgs) => {
    const loadingId = customToastManager.addToast(msgs.loading, "loading");
    return promise
      .then((result) => {
        customToastManager.removeToast(loadingId);
        customToastManager.addToast(msgs.success, "success");
        return result;
      })
      .catch((error) => {
        customToastManager.removeToast(loadingId);
        customToastManager.addToast(msgs.error, "error");
        throw error;
      });
  },
};

export default toast;
